// IndicacionVisitaInput
// record:
// (int IdInsumo, int CantidadDiaria)
export const adaptIndicacionVisitaInput = (data) => ({
    idInsumo: data?.idInsumo,
    cantidadDiaria: data?.cantidadDiaria,
});

// Helper para listas del tipo List<IndicacionVisitaInput>
export const adaptListaIndicacion = (lista) =>
    lista?.map(adaptIndicacionVisitaInput);

// IndicacionVisitaBAPInput
// record:
// (bool BAPMagistral, decimal? VolumenMagistral,
//  bool BAPEstandar, decimal? VolumenEstandar,
//  int? IdInsumo, int? IdComboRIValorMotivoEstadar, int? IdComboRIValorMotivoMagistral)
export const adaptIndicacionVisitaBAPInput = (data) => ({
    bAPMagistral: !!data?.bAPMagistral,
    volumenMagistral: (data?.bAPMagistral)?data?.volumenMagistral:null,
    bAPEstandar: !!data?.bAPEstandar,
    volumenEstandar: (data?.bAPEstandar)?data?.volumenEstandar:null,
    idInsumo: (data?.bAPEstandar)?data?.idInsumo:null,
    idComboRIValorMotivoEstadar: (data?.bAPEstandar)?data?.idComboRIValorMotivoEstandar:null,
    idComboRIValorMotivoMagistral: (data?.bAPMagistral)?data?.idComboRIValorMotivoMagistral:null,
});